import { request } from 'Lib/axios'
import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

const setMigrationMonitorMode = async (accountId: number, domains: string[]) => {
  return await request({
    url: `accounts-migration/${accountId}/monitor-mode`,
    method: 'POST',
    data: { domains },
  })
}

export const useSetMigrationMonitorMode = () => {
  const { accountId } = useUserStore.getState()

  return useMutation({
    mutationFn: (domains: string[]) => setMigrationMonitorMode(accountId, domains),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getMigrationMonitorMode'] })
    },
  })
}
